import { BaseRepository } from "@/repositories/base-repository"
import { type IKnownBusinessEntityRentalDispenseItem } from "@/interfaces/api/known-business-entity-rental-dispense-item.interface.ts"

export class KnownBusinessEntityRentalDispenseItemRepository extends BaseRepository<IKnownBusinessEntityRentalDispenseItem> {
  protected resourcePath = "administration/known-business-entities-rental-dispense-items"
}
